module.exports = __webpack_public_path__ + "img/visa.6c10bd8c.png";